// Every module compiled into this build. Manifests only: tiny, always loaded, so the
// dropdown and landing need no module code. Each module's code arrives on first open,
// except Support's, which its manifest imports eagerly (R12, R14: the module everyone
// opens first must not depend on a lazy chunk arriving).
import support from '../src/support-module/manifest.js';
import implementation from '../../modules/implementation/manifest.ts';
import inventory from '../../modules/inventory/manifest.ts';
import { validateManifests } from './module-logic.js';

export const REGISTERED_MODULES = validateManifests([support, implementation, inventory]);
